<script setup lang="ts">
import { computed } from '#imports'

interface Props {
  /**
   * The numerical value to determine the pluralization.
   * @default 0
   */
  count?: number
  /**
   * The singular form of the word (e.g., "policy").
   */
  singular: string
  /**
   * The plural form of the word (e.g., "policies").
   * If not provided, it defaults to the singular form with an 's' appended.
   */
  plural?: string
  /**
   * The HTML tag to use for rendering.
   * @default 'span'
   */
  tag?:
    | 'span'
    | 'p'
    | 'strong'
    | 'em'
    | 'b'
    | 'i'
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'div'
}

const { count = 0, singular, plural = '', tag = 'span' } = defineProps<Props>()

const pluralizedWord = computed(() =>
  count === 1 ? singular : plural || `${singular}s`,
)
</script>

<template>
  <component :is="tag">
    {{ pluralizedWord }}
  </component>
</template>
